// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Browser } from "@capacitor/browser";
import { isDefined, toError } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { logError } from "@src/appV2/lib/analytics/log";

import { useSendCheckrInvitation } from "./useSendCheckrInvitation";

export function useOpenCheckrInvitation() {
  const { mutateAsync: sendCheckrInvitation } = useSendCheckrInvitation();

  return async () => {
    try {
      const { data: updatedCheckrApplicationStatus } = await sendCheckrInvitation();
      const { invitationUrl } = updatedCheckrApplicationStatus;

      if (isDefined(invitationUrl)) {
        await Browser.open({
          url: invitationUrl,
        });
      } else {
        logError(APP_V2_APP_EVENTS.RESEND_CHECKR_INVITATION_FAILURE, {
          error: new Error("No invitation url included in the response"),
          metadata: {
            updatedCheckrApplicationStatus,
          },
        });
      }
    } catch (maybeError: unknown) {
      logError(APP_V2_APP_EVENTS.RESEND_CHECKR_INVITATION_FAILURE, {
        error: toError(maybeError),
      });

      throw toError(maybeError);
    }
  };
}
